import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import MenuItem from "./MenuItem";
import { useAppState } from "../../context/appContex";

const SubMenu: React.FC = () => {
  const [selectedId, setSelectedId] = useState("");
  const [inputValue, setInputValue] = useState("");

  const { menuData } = useAppState();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const toggleMenu = (id: string) => {
    if (id) {
      if (selectedId && id === selectedId) {
        setSelectedId("");
      } else {
        setSelectedId(id);
      }
    }
  };

  return (
    <ul className='submenu-wrapper'>
      {menuData?.items.map((item) => {
        const { isGroup, isVisible, title, targetType, targetUrl, id } = item;
        const isPop = targetUrl.includes("popup.php");

        if (isVisible) {
          return (
            <li
              className={
                selectedId === id ? "nav-item active-menu" : "nav-item"
              }
              key={id}
              // onClick={() => {
              //   if (isGroup) {
              //     toggleMenu(id);
              //   }
              // }}
            >
              {isGroup ? (
                <span
                  onClick={() => {
                    toggleMenu(id);
                  }}
                  className='nav-text'
                  style={selectedId === id ? { fontWeight: "bold" } : {}}
                >
                  {title}
                </span>
              ) : isPop || targetType === "BLANK" ? (
                <a
                  href={targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='nav-text'
                >
                  {title}
                </a>
              ) : (
                <a className='nav-text' href={targetUrl}>
                  {title}
                </a>
              )}
              {item.isGroup && (
                <>
                  {selectedId && selectedId === id ? (
                    <FeatherIcon
                      icon='chevron-down'
                      className='drop-down'
                      onClick={() => toggleMenu(id)}
                    />
                  ) : (
                    <FeatherIcon
                      icon='chevron-right'
                      className='drop-down'
                      onClick={() => toggleMenu(id)}
                    />
                  )}
                </>
              )}

              {selectedId === id ? (
                <MenuItem
                  item={item}
                  onChange={onChange}
                  inputValue={inputValue}
                />
              ) : null}
            </li>
          );
        }
        return null;
      })}
    </ul>
  );
};

export default SubMenu;
